import { Injectable } from '@angular/core';
import { Store } from '@ngxs/store';
import * as SCFMastersActions from './scf-masters.action';
import { GeneralSignalRResponse } from 'src/app/services/signal-r/general-signal-r-response';
import { SignalRService } from 'src/app/services/signal-r/signal-r.service';
import { SignalRAction } from 'src/app/services/signal-r/signalr-enums';
import { Channels } from 'src/app/store/channels';

@Injectable({
  providedIn: 'root'
})
export class SCFMastersStoreAndListenersService {
  constructor(private store: Store, private signalRService: SignalRService) { }
  initStore() {
    this.store.dispatch(new SCFMastersActions.SCFMastersRefresh());
  }

  initListeners() {
    this.signalRService.hubConnection?.on(Channels.SCF_MASTERS, (data: GeneralSignalRResponse) => {
      this.signalRService.setSender(data.userID);
      switch (data.action) {
        case SignalRAction.Add:
          this.store.dispatch(new SCFMastersActions.SCFMastersCreate(data.obj));
          break;

        case SignalRAction.Update:
          this.store.dispatch(new SCFMastersActions.SCFMastersUpdate(data.id, data.obj));
          break;

        case SignalRAction.Delete:
          this.store.dispatch(new SCFMastersActions.SCFMastersDelete(data.id));
          break;

        case SignalRAction.Get:
          this.store.dispatch(new SCFMastersActions.SCFMastersRefresh());
          break;

        case SignalRAction.RequestRefresh:
          this.store.dispatch(new SCFMastersActions.SCFMastersRefreshById(data.id));
          break;
      }
    });
  }
}
